<template>
  <transition name="fade" mode="out-in">
    <v-expansion-panel key="favourites" v-if="favourites && favourites.length > 0">
      <v-expansion-panel-content :key="favourite.id" v-for="favourite in favourites">
        <template v-slot:header>
          <div>{{favourite.title}}</div>
        </template>

        <Tag :item="favourite"></Tag>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <div key="no-results" class="text-xs-center mt-4" v-else>
      <i>No favourites found - Hit search to go find some!</i>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

import Tag from "./Tag.vue";

export default {
  components: {
    Tag
  },

  computed: {
    ...mapGetters(["favourites"])
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>